import api from "../../api/datadash";
import router from "../../router";

const state = {
  token: window.localStorage.getItem("datadash_token"),
  error: "",
  errorStatus: "",
  successStatus: "",
  responseMsg: "",
  clientId: "",
  userRole: "",
  test: "",
};

const getters = {
  isLoggedIn: (state) => {
    return !!state.token;
  },
  getMenus: (state) => {
    if (!state.token) {
      return [
        {
          icon: "engineering",
          type: "button",
          title: "How it works",
          link: "/description",
        },
        {
          icon: "money",
          title: "Price",
          type: "button",
          link: "/subscription-price",
          // link: "/price",
        },
        {
          icon: "lock_open",
          title: "Sign in",
          type: "button",
          link: "/signin",
        },
        {
          icon: "face",
          title: "Sign up",
          type: "button",
          link: "/signup",
        },
      ];
      // return [
      //   {
      //     title: "How it works",
      //     items: [
      //       { icon: "money", title: "How it works", link: "/description" },
      //     ],
      //   },
      //   {
      //     title: "Pricing",
      //     items: [{ icon: "money", title: "Price", link: "/price" }],
      //   },
      //   {
      //     title: "Login",
      //     items: [{ icon: "lock_open", title: "Sign in", link: "/signin" }],
      //   },
      //   {
      //     title: "Signup",
      //     items: [{ icon: "face", title: "Sign up", link: "/signup" }],
      //   },
      // ];
    } else {
      return [
        {
          title: "Project",
          items: [
            { icon: "", title: "Create New Project", link: "/create-project" },
            { icon: "", title: "Project List", link: "/project-list" },
            { icon: "", title: "All Created Project", link: "/all-project" },
            {
              icon: "",
              title: "Search In Responses",
              link: "/search-in-response",
            },
            // {icon:'', title: 'Budget', link: '/budget'},
            //here have a problem
            // {icon:'', title: 'Last Created Project', link: '/client-view'},
          ],
        },
        {
          title: "System Settings",
          items: [
            { icon: "", title: "Division", link: "/division" },
            { icon: "", title: "District", link: "/district" },
            { icon: "", title: "Upazila", link: "/upazila" },
            { icon: "", title: "Gender", link: "/gender" },
            { icon: "", title: "DefaultMeta", link: "/default-meta" },
            { icon: "", title: "Marital Status", link: "/marital-status" },
            { icon: "", title: "Gateway Charge", link: "/gateway-charge" },
            {
              icon: "",
              title: "Educational Qualification",
              link: "/education",
            },
            { icon: "", title: "Income Type", link: "/income-type" },
            { icon: "", title: "Occupation Type", link: "/occupation-type" },
            { icon: "", title: "Monthly Income", link: "/monthly-income" },
            {
              icon: "",
              title: "Notification Message",
              link: "/notify-message",
            },
            { icon: "", title: "Faqs", link: "/faq" },
          ],
        },
        {
          title: "Project Settings",
          items: [
            {
              icon: "",
              title: "Comparison Operator",
              link: "/comparison-operator",
            },
            {
              icon: "",
              title: "Project Filtering Parameter",
              link: "/project-filtering-parameter",
            },
            // { icon: '', title: 'Project Filtering Settings', link: '/project-filtering-setting' },
            { icon: "", title: "Project Types", link: "/project-type" },
            { icon: "", title: "Ui Category", link: "/ui-category" },
            { icon: "", title: "Project Status", link: "/project-status" },
            { icon: "", title: "Nearby Distance", link: "/nearby-radius" },
            // {icon:'', title: 'Question Options', link: '/question-option'},
            // {icon:'', title: 'Question Orders', link: '/question-order'},
            // {icon:'', title: 'Conditional Orders', link: '/conditional-order'},
            { icon: "", title: "Marketplace Type", link: "/wallet-type" },
            // { icon: "", title: "Point Message", link: "/point-message" },
            { icon: "", title: "Point Rule", link: "/point-rule" },
            { icon: "", title: "Rank", link: "/rank" },
            // { icon: "", title: "Coin Message", link: "/coin-message" },
            { icon: "", title: "Coin Rule", link: "/coin-rule" },
          ],
        },
        // {
        //   title: "Team",
        //   items: [
        //     { icon: "groups", title: "Team Management", link: "/team-management" },
        //     { icon: "", title: "Create Team", link: "/create-team" },
        //     {
        //       icon: "",
        //       title: "Assign Dasher To Team",
        //       link: "/assign-dasher-to-team",
        //     },
        //     {
        //       icon: "",
        //       title: "Dasher Team Status",
        //       link: "/dasher-team-status",
        //     },
        //   ],
        // },
        {
          title: "Reports",
          items: [
            {
              icon: "",
              title: "Project Summary Report",
              link: "/project-summary-report",
            },
            {
              icon: "",
              title: "Dasher Summary Report",
              link: "/dasher-summary-report",
            },
            {
              icon: "",
              title: "Dasher Coin Balance Report",
              link: "/dasher-coin-balance-report",
            },
            {
              icon: "",
              title: "Dasher Daily Cash Out Report",
              link: "/dasher-daily-cash-out-report",
            },
          ],
        },
        {
          title: "User Role",
          items: [
            // { icon: "face", title: "User Profile", link: "/user-profile" },
            { icon: "", title: "Role", link: "/role" },
            { icon: "", title: "Url", link: "/url" },
            { icon: "", title: "Url To Role", link: "/url-role" },
            // { icon: "", title: "Official User", link: "/official-user" },
            // { icon: "", title: "Role To User", link: "/role-user" },
          ],
        },
        // {
        //   title: "Notifications",
        // },
        // {
        //   title: "Agent",
        //   items: [
        //     { icon: "diversity_3", title: "Agent Management", link: "/agent-management" },
        //     { icon: "", title: "Agent Group", link: "/agent-group" },
        //     {
        //       icon: "",
        //       title: "Assign Agent To Group",
        //       link: "/assign-agent-to-group",
        //     },
        //     {
        //       icon: "",
        //       title: "Agent To Group Status",
        //       link: "/assign-agent-to-group-status",
        //     },
        //     {
        //       icon: "",
        //       title: "Define Project Task To Agent",
        //       link: "/define-task-to-agents",
        //     },
        //   ],
        // },
        {
          title: "Clementine",
          items: [
            { icon: "", title: "Approval Status", link: "/all-status" },
            {
              icon: "",
              title: "User Device Info",
              link: "/user-device-info",
            },
            {
              icon: "",
              title: "Client",
              link: "/client",
            },
            {
              icon: "",
              title: "Dasher Delete Request",
              link: "/dasher-delete-request",
            },
            {
              icon: "",
              title: "Assistant Request",
              link: "/assistant-request",
            },
            {
              icon: "",
              title: "Demo Request",
              link: "/demo-request",
            },

            {
              icon: "",
              title: "Service",
              link: "/service",
            },
            {
              icon: "",
              title: "Package",
              link: "/package",
            },
            {
              icon: "",
              title: "Package Price",
              link: "/package-price",
            },
            {
              icon: "",
              title: "Package UiCategory",
              link: "/package-ui-category",
            },
            {
              icon: "",
              title: "Package Detail",
              link: "/package-detail",
            },
            {
              icon: "",
              title: "Client's Subscription Plan",
              link: "/client-subscription-plan",
            },
          ],
        },
        // {
        //   title: "Me",
        //   icon: "",
        //   items: [
        //     { icon: "face", title: "User Profile", link: "/user-profile" },
        //     { icon: "lock", title: "Signout", link: "/signin" },
        //   ],
        // },
        // {
        //   icon: "face", title: "User Profile", link: "/user-profile"
        // },
      ];
    }
  },
  getAuthResponse: (state) => {
    if (state.error) {
      return state.responseMsg;
    }
  },
  getAuthSigninResponse: (state) => {
    if (state.error) {
      return state.responseMsg;
    }
  },
  clientId: (state) => {
    if (state.clientId) {
      return window.localStorage.getItem("client_id");
    }
  },
  userRole: (state) => {
    if (state.clientId) {
      return window.localStorage.getItem("user_role");
    }
  },
  token: (state) => {
    if (state.token) {
      // return state.token;
      return window.localStorage.getItem("datadash_token");
    }
  },
};

const actions = {
  async login({ commit }, allLogData) {
    const response = await api.login(allLogData, "login");
    // console.log(response);
    if (response.data.error == 1) {
      commit("setAuthResponse", response);
      router.push("/signin");
    } else {
      commit("setToken", response);
      window.localStorage.setItem(
        "datadash_token",
        response.data.data.users.api_token
      );

      window.localStorage.setItem(
        "client_id",
        response.data.data.users.client_id
      );
      window.localStorage.setItem(
        "user_role",
        JSON.stringify(response.data.data.users.role)
      );
      if (response.data.data.users.client_id == 1) {
        router.push("/");
      } else {
        // router.push("/");
        router.push("/project-list");
      }
    }
  },

  async register({ commit }, allRegData) {
    const response = await api.register(allRegData, "signup");
    if (response.data.error) {
      commit("setAuthResponse", response);
      router.push("/signup");
    } else {
      alert(response.data.errorMsg);
      router.push("/signin");
    }
  },

  async logout({ commit }) {
    // we use commit instead of mutations there are several reasons for that. there might be several request
    commit("setToken", "");
    window.localStorage.removeItem("datadash_token");
    window.localStorage.removeItem("client_id");
    router.push("/signin");
  },
};

const mutations = {
  setToken: (state, response) => {
    if (response == "") {
      state.token = "";
    } else {
      // console.log(response.data.data);
      state.token = response.data.data.users.api_token;
      state.clientId = response.data.data.users.client_id;
      state.userRole = response.data.data.users.role;
      state.error = response.data.error;
      state.successStatus = response.data.statusCode;
      state.responseMsg = response.data.errorMsg;
    }
  },
  setTest: (state, response) => {
    state.test = response;
  },
  setAuthResponse: (state, response) => {
    state.test = response;
    state.error = response.data.error;
    state.errorStatus = response.data.statusCode;
    state.responseMsg = response.data.errorMsg;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
